import { SettingsConfig } from "../settings-type";
import { FLAG_NAMES } from "../flag-constants";

const stagingSettings: Partial<SettingsConfig> = {
  [FLAG_NAMES.DATADOG_RUM_ENABLED]: true,
};

export default stagingSettings;
